module.exports = __webpack_public_path__ + "img/dynamic-11.9ca6984b.png";